import React, {Component} from 'react';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';

import {Button, Card, Select, Form, Input, notification} from 'antd';

import {addUser} from './actions';
import {bindActionCreators} from "redux";
import {handleFormErrorNotification} from "../utils/errors";
import {formItemLayout} from "../utils/style";
import permissions from "./permissions";

const FormItem = Form.Item;
const Option = Select.Option;
const ButtonGroup = Button.Group;

function hasErrors(fieldsError) {
  return Object.keys(fieldsError).some(field => fieldsError[field]);
}

class AddUserForm extends Component {
  goBack = () => {
    this.props.history.goBack();
  };

  handleConfirmPassword = (rule, value, callback) => {
    const {getFieldValue} = this.props.form;
    if (value && value !== getFieldValue('password')) {
      callback('Both password must be the same');
    }
    callback();
  };

  handleSubmit = e => {
    e.preventDefault();
    const {form: {setFields}} = this.props;
    this.props.form.validateFields((err, values) => {
      if (err) return;
      this.props.addUser(values)
        .then(this.goBack)
        .catch(err => handleFormErrorNotification(err, values, setFields, notification));
    });
  };

  render() {
    const {form: {getFieldDecorator, getFieldsError}, loading, auth} = this.props;
    return (
      <Card title="Add User">
        <Form onSubmit={this.handleSubmit}>
          <FormItem
            {...formItemLayout}
            label="Username"
          >
            {getFieldDecorator('username', {
              rules: [{
                required: true, min: 4
              }]
            })(
              <Input autoFocus/>
            )}
          </FormItem>
          <FormItem
            {...formItemLayout}
            label="Password"
          >
            {getFieldDecorator('password', {
              rules: [{
                required: true, min: 8
              }],
              initialValue: '',
            })(
              <Input type="password"/>
            )}
          </FormItem>
          <Form.Item label="Confirm password" {...formItemLayout}>
            {getFieldDecorator('confirmPassword', {
              initialValue: '',
              rules: [
                {required: true, min: 8},
                {validator: this.handleConfirmPassword},
              ]
            })(
              <Input type="password"/>
            )}
          </Form.Item>
          <FormItem
            {...formItemLayout}
            label="Permissions"
          >
            {getFieldDecorator('permissions', {
              rules: [{
                required: true
              }],
            })(
              <Select mode="multiple" placeholder="Select permissions">
                {permissions
                  .filter(x => !x.requirePermission || auth.hasPermission(x.requirePermission))
                  .map(({value, text}) => <Option key={value} value={value}>{text}</Option>)}
              </Select>
            )}
          </FormItem>
          <FormItem>
            <ButtonGroup>
              <Button
                type="primary"
                htmlType="submit"
                disabled={loading || hasErrors(getFieldsError())}
              >
                Add User
              </Button>
              <Button
                htmlType="button"
                onClick={this.goBack}
              >
                Cancel
              </Button>
            </ButtonGroup>
          </FormItem>
        </Form>
      </Card>
    );
  }
}

AddUserForm.propTypes = {
  form: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired,
  auth: PropTypes.object.isRequired,
  loading: PropTypes.bool.isRequired,
  /* actions */
  addUser: PropTypes.func.isRequired,
};

const AddUserPage = Form.create()(AddUserForm);

const mapStateToProps = state => ({
  loading: state.user.addingUser,
});

const mapDispatchToProps = dispatch => ({
  addUser: bindActionCreators(addUser, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(AddUserPage);



// WEBPACK FOOTER //
// ./src/User/AddUserPage.js